import { getContinentCode, getContinentName } from '@brixtol/country-continent';
import sort from '@alpinejs/sort';
import './filament-one-time-code-input.js';

window.Alpine.plugin(sort);

window.CountryContinent = { getContinentCode, getContinentName };
